import { Article } from '../../types/Article';
import createInfiniteScrollStore from '../infiniteScrollStore';

export const useArticlesStore = createInfiniteScrollStore<Article>();
